import CurrentEvents from './CurrentEvents';

export default CurrentEvents;